/** 按资产名称去重，保留首次出现项 */
export function dedupeEquityByAssetName(list) {
	if (!Array.isArray(list)) return [];
	const seen = new Set();
	return list.filter((item) => {
		const name = item && item.assetName != null ? String(item.assetName).trim() : '';
		if (seen.has(name)) return false;
		seen.add(name);
		return true;
	});
}

/** 代管股权展示列表（暂无独立接口时使用） */
export const DAIGUAN_EQUITY_LIST = [
	{ assetName: '枣庄市财金控股集团有限公司' },
	{ assetName: '山东省金融资产管理有限公司' },
];

/** 代管集团投资主体（同兴长投收益对应企业） */
const DAIGUAN_KEYWORDS = ['山东省金融资产管理', '山东金融资产管理'];

export function isDaiguanEquityItem(item) {
	const text = `${item.assetName || ''}${item.description || ''}${item.assetCode || ''}`;
	return DAIGUAN_KEYWORDS.some((k) => text.includes(k));
}

export function collectOrgTreeNames(node, nameSet = new Set()) {
	if (!node) return nameSet;
	if (node.name) nameSet.add(node.name);
	(node.children || []).forEach((child) => collectOrgTreeNames(child, nameSet));
	return nameSet;
}

/**
 * 拆分股权资产列表：代管 / 资产公司（子公司树内企业）
 */
export function splitEquityAssetList(allList, orgTreeRoot) {
	const all = Array.isArray(allList) ? allList : [];
	const daiguanList = all.filter(isDaiguanEquityItem);
	const orgNames = collectOrgTreeNames(orgTreeRoot);
	let companyList = all.filter((item) => orgNames.has(item.assetName));
	if (!companyList.length) {
		companyList = all.filter((item) => !isDaiguanEquityItem(item));
	}
	return { daiguanList, companyList };
}

/**
 * 股权资产持有数弹窗数据：自有股权 + 代管股权
 * 自有股权 = 股权资产接口返回的全部企业（去重）
 * 代管股权 = 固定 2 家（暂无独立接口）
 */
export function getEquityHoldPanels(allList) {
	const owned = dedupeEquityByAssetName(Array.isArray(allList) ? allList : []);
	const daiguan = [...DAIGUAN_EQUITY_LIST];

	return {
		companyList: owned.map((item) => Object.assign({ assetType: '股权资产' }, item)),
		daiguanList: daiguan,
		holdCount: owned.length + daiguan.length,
	};
}
